<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.75 4C8.75 3.58579 8.41421 3.25 8 3.25C7.58579 3.25 7.25 3.58579 7.25 4V8.22146C7.25 8.48631 7.3897 8.73153 7.61753 8.8666L10.6175 10.6451C10.9738 10.8564 11.4339 10.7388 11.6451 10.3825C11.8564 10.0262 11.7388 9.56609 11.3825 9.35485L8.75 7.7942V4Z"
    fill="currentColor"
  />
</template>
